import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
  children: ReactNode;
}

const classes: Record<Variant, string> = {
  primary:
    'bg-brand text-white hover:bg-brand-600 focus:ring-brand disabled:bg-brand-50 disabled:text-brand-500',
  secondary:
    'bg-white text-brand border border-brand-100 hover:bg-brand-50 focus:ring-brand',
  ghost: 'bg-transparent text-slate-700 hover:bg-slate-100',
  danger: 'bg-red-600 text-white hover:bg-red-700',
};

export function Button({
  variant = 'primary',
  loading,
  children,
  className = '',
  disabled,
  ...rest
}: Props) {
  return (
    <button
      {...rest}
      disabled={disabled || loading}
      className={`inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-medium transition focus:outline-none focus:ring-2 focus:ring-offset-1 disabled:cursor-not-allowed ${classes[variant]} ${className}`}
    >
      {loading ? <span className="animate-pulse">...</span> : null}
      {children}
    </button>
  );
}
